(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.progressService', [])

        .service('newOrderProgressService', function () {
            var _this = this;

            angular.extend(_this, {
                init: init,
                getProgress: getProgress,
                setFileProgress: setFileProgress
            });

            var _filesSize = 0;
            var _progressItems = [];

            return _this;

            function init(filesSize) {
                _filesSize = filesSize;
                _progressItems = [];
            }

            function getProgress() {
                var uploadedSize = 0;
                angular.forEach(_progressItems, function (progressItem) {
                    uploadedSize += progressItem.file.size * (progressItem.progress / 100);
                })
                return Math.round((uploadedSize / _filesSize) * 100);
            }

            function setFileProgress(file, progress, sessionId) {
                var itemFound = _.find(_progressItems, function (item) {
                    return (item.file.name === file.name) && (item.sessionId === sessionId);
                });

                if (itemFound) {
                    itemFound.progress = progress;
                } else {
                    _progressItems.push(new fileProgressItem(file, progress, sessionId));
                }
            }

            function fileProgressItem(file, progress, sessionId) {
                var _this = this;

                _this.file = file;
                _this.progress = progress;
                _this.sessionId = sessionId;
            }
        })
    ;
})(window.angular);
